import React, { Fragment, useState, useEffect } from 'react';

import { getIndentClass } from '../../utils/styleUtils';

import RevenueCostcenterRow from './RevenueCostcenterRow';
import RevenueRow from './RevenueRow';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

function RevenueDepartmentRow(props) {
    const [showDepartment, setShowDepartment] = useState(false);

    // Handle expand all trigger from parent with staggered updates
    useEffect(() => {
        const t = props.expandAllTrigger;
        if (!t?.version) return;

        if (t.batch === 'departments') {
            setShowDepartment(t.expanded);
        }
    }, [props.expandAllTrigger?.version]);

    // Calculate indentation level (Department is level 0)
    const indentLevel = props.indentLevel;
    const childIndentLevel = indentLevel + 1;

    const { department, editingRevenueId, periods, maxRevenueMilestonesCount = 3, expandAllTrigger, ...restProps } = props;

    return (
        <>
            <tr className="!tw-bg-blue-25">
                <td className="tw-font-bold tw-cursor-pointer !tw-border-r-0" onClick={() => setShowDepartment(!showDepartment)}>
                    <div className={`tw-flex tw-items-center tw-gap-x-1.5 ${getIndentClass(indentLevel)}`}>
                        <div className="!tw-text-blue">{department.name}</div>
                        <div>{showDepartment ? <ChevronUpIcon /> : <ChevronDownIcon />}</div>
                    </div>
                </td>
                <td className="tw-p-4 !tw-border-x-0"></td>
                <td className="tw-font-bold tw-cursor-pointer tw-border-r-2" onClick={() => setShowDepartment(!showDepartment)}></td>
                <td
                    colSpan={maxRevenueMilestonesCount * 2 + 3}
                    className="tw-font-bold tw-cursor-pointer !tw-border-l-0"
                    onClick={() => setShowDepartment(!showDepartment)}
                ></td>
            </tr>
            {showDepartment && (
                <Fragment>
                    {department.costcenters &&
                        department.costcenters.length > 0 &&
                        department.costcenters.map((costcenter) => (
                            <RevenueCostcenterRow
                                {...restProps}
                                key={`costcenter_${costcenter.id}`}
                                costcenter={costcenter}
                                editingRevenueId={editingRevenueId}
                                periods={periods}
                                maxRevenueMilestonesCount={maxRevenueMilestonesCount}
                                indentLevel={childIndentLevel}
                                expandAllTrigger={expandAllTrigger}
                            />
                        ))}
                    {department.revenues &&
                        department.revenues.length > 0 &&
                        department.revenues.map((revenue) => (
                            <RevenueRow
                                {...restProps}
                                key={`revenue_${revenue.id}`}
                                revenue={revenue}
                                editingRevenueId={editingRevenueId}
                                periods={periods}
                                maxRevenueMilestonesCount={maxRevenueMilestonesCount}
                                indentLevel={childIndentLevel}
                                expandAllTrigger={expandAllTrigger}
                            />
                        ))}
                </Fragment>
            )}
        </>
    );
}

// Memoize component to prevent unnecessary re-renders
export default React.memo(RevenueDepartmentRow);
